import { NgModule } from '@angular/core';
import { UsersService } from './users.service';
import { User } from './user';
import { RouterModule } from '@angular/router';
import { UIElementModule } from 'src/app/core';
import { ExerciceList } from './_tpl/exercice/exercice-list';


let declarationAndExports = [
	User,
	ExerciceList
]
@NgModule({
	imports: [RouterModule, UIElementModule],
	declarations: [declarationAndExports],
	exports: [declarationAndExports],
	providers: [UsersService]
})
export class UsersModule { }
